import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CareerService } from '../careers.service';
import { ToastrService } from 'ngx-toastr';
import { Career } from '../../shared/types/career.model';

@Component({
  selector: 'mmb-web-app-modal-external-apply',
  templateUrl: './modal-external-apply.component.html',
  styleUrls: ['./modal-external-apply.component.scss']
})
export class ModalExternalApplyComponent implements OnInit {
  @Input() orgLogo: string;
  @Input() orgName: string;
  @Input() redirectUrl: string;
  @Input() careerId: number;
  @Input() career: Career;
  @Output() submitted: EventEmitter<any> = new EventEmitter<any>();
  externalApplyForm: UntypedFormGroup;
  options = [];
  intentValue: string;

  constructor(public modal: NgbActiveModal, private fb: UntypedFormBuilder, private careerService: CareerService, private toastr: ToastrService) { }

  ngOnInit() {
    this.externalApplyForm = this.fb.group({
      intent: ['', Validators.required],
      yourRequests: [''],
    });
    this.options = [
      {
        value: '1',
        viewValue: 'Submit an application'
      },
      {
        value: '3',
        viewValue: 'Get more information on the role'
      },
      {
        value: '4',
        viewValue: `Contact ${this.orgName}`
      },
      {
        value: '2',
        viewValue: 'General browsing and exploring'
      },
      {
        value: '5',
        viewValue: `Find other ${this.orgName} opportunities`
      }
    ];
  }

  /**
   * On continue to external application
   */
  onContinue() {
    let redirectRef: string = `?ref=${this.createRedirectRef()}&referrer=movemeback.com`;
    let payload = {
      'career': this.careerId,
      'redirect_url': this.redirectUrl,
      'intent': this.externalApplyForm.controls['intent'].value,
      'value': this.externalApplyForm.controls['intent'].value,
      'notes': this.externalApplyForm.controls['yourRequests'].value,
      'redirect_count': '1',
      'redirect_ref': redirectRef
    };

    if (!this.career.applied_external) {
      this.careerService.onExternalApplication(payload).subscribe(() => {
        this._successHandler(redirectRef);
      }, (err) => {
        this._errorHandler(err);
      });
    } else {
      this.careerService.onUpdateExternalApplication(this.career.applied_external.uuid, payload).subscribe(() => {
        this._successHandler(redirectRef);
      }, (err) => {
        this._errorHandler(err);
      });
    }
  }

  /**
   * Generates redirect reference
   */
  private createRedirectRef() {
    return Date.now() + 'u' + localStorage.getItem('username') + Math.random().toString().substr(2, 20);;
  }

  /**
   * Success handler
   * @param redirectRef 
   */
  private _successHandler(redirectRef: string) {
    this.submitted.emit();
    window.open(`${this.redirectUrl}${redirectRef}`);
  }
  /**
   * Error handler
   * @param err 
   */
  private _errorHandler(err) {
    if (err && err.error && err.error.non_field_errors) {
      this.toastr.error(err.error.non_field_errors);
    } else {
      this.toastr.error('Error occurred while registering the event. Please contact admin!');
    }
  }
}
